/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useRef, useState } from 'react'
import { Table, OverlayTrigger, Row, Col, Spinner } from 'react-bootstrap'
import FeatherIcon from 'feather-icons-react';
import BrowseCategoriesModal from './Modal/BrowseCategoriesModal';
import { renderTooltipDelete } from '../tooltips/SaleOrders__ProductsTooltips'
import { cancelGetCategoriesTreeApi, getCategoriesTree } from 'utlis/Apis/Categories_API';
import { ERROR_WHILE__NAME } from 'utlis/AppMessages/AppMessages';
import { UNKNOWN_ERROR_OCCURED } from 'utlis/AppMessages/AppMessages';
import { toast } from 'react-toastify';
import { connect } from 'react-redux';
import { setGlobalLoading } from 'redux/actions/actionCommon';
import { ERROR_WHILE_FETCHING_PRODUCTS } from 'utlis/AppMessages/AppMessages';
import { getProductVaraitons } from 'utlis/Apis/Products_API';
import { Link } from 'react-router-dom';
import AppFormikInputFieldRadio from 'utlis/helpers/forms/AppFormikInputFieldRadio';
import { deleteCart } from 'utlis/Apis/Cart_API';
import useStoreUrl from 'utlis/CustomHooks/useStoreUrl';

function Product({ item, selectedProducts, index, setSelectedProducts, lines }) {
    const [selected, setSelected] = useState(item.selected || lines.filter(e => (e.variant_sku || e.variant_sku) === (item.variant_sku || item.variant_sku)).length > 0)

    return (
        <>
            <div className="d-flex align-items-center justify-content-between product-item">
                <div id="sale-product">
                    <AppFormikInputFieldRadio
                        value={selected}
                        checked={selected}
                        stFormClass={`st-form st-form-with-label-left d-flex flex-wrap align-items-center justify-content-left ${selected ? "text-primary" : ""}`}
                        formikFieldName={"" + item.product_id}
                        labelNameRight={item.product_name}
                        onChange={(e) => {
                            setSelected(!selected)
                            const array = setSelectedProducts
                            item.selected = e.target.checked
                            item.quantity = 1
                            array[index] = item
                            setSelectedProducts(arr => array)
                        }}
                    />
                    <div className="variant_sku">{item.variant_sku || item.sku}</div>
                    <div className="variant">{item.variant}</div>
                </div>
                <div className={`st-fs-12 ${(item.variant_stock || item.stock) === 0 ? "text-danger" : "text-success"}`} >
                    {(item.variant_stock || item.stock) === 0 ? "out of stock" : "Stock: " + (item.variant_stock || item.stock)}
                </div>
            </div>
        </>
    )

}
let timeOut = ""
function SaleOrdersProductsTable(props) {
    const { authState, formik, lines, setLines, token_id, currency } = props;
    const [showBrowseCatogoriesModal, setShowBrowseCatogoriesModal] = useState(false);
    const [categoriesList, setCategoriesList] = useState([])
    const [products, setProducts] = useState([])
    const [searchProducts, setSearchProducts] = useState([])
    const [category_name, setCategory_name] = useState('')
    const [foundCategory, setFoundcategory] = useState([])
    const [product_loading, setProductLoading] = useState(false)
    const [search, setSearch] = useState("")
    const [product_name, setProduct_name] = useState('')
    const [foundProduct, setFoundProduct] = useState([])
    const [dropDownList, setDropDownList] = useState(0)

    // store url
    const [storeUrl] = useStoreUrl()

    useEffect(() => {
        let URLParams = `limit=-1`
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getCategoriesTree(headers, URLParams).then(res => {
            const resData = res.data
            if (resData && resData.success) {
                setCategoriesList(resData.data)
                setFoundcategory(resData.data)
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(UNKNOWN_ERROR_OCCURED, {
                    autoClose: 2500
                })
            }
        }).catch(err => {
            console.log(`${ERROR_WHILE__NAME} getCategories `, err.message)
            toast.dismiss();
            toast.error(UNKNOWN_ERROR_OCCURED, {
                autoClose: 2500
            })
        })
        return () => {
            cancelGetCategoriesTreeApi()
        }
    }, [authState])

    const deleteCart_ = (item) => {
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        deleteCart(headers, item.cart_id, token_id).then(res => { }).catch(e => { })
    }
    const getProducts_ = (category, keyword) => {
        setProducts(arr => [])
        setFoundProduct(arr => [])
        setSearchProducts(arr => [])
        setProductLoading(true)
        const headers = {
            "Authorization": `Bearer ${authState.commonToken}`,
            "Api-Token": authState.apiToken,
            "Access-Token": "",
            // "Store-Id": authState.storeId,
        }
        getProductVaraitons(headers, category, keyword).then(res => {
            const resData = res.data
            setProductLoading(false)
            if (resData && resData.success) {
                if (!category) {
                    setSearchProducts(resData.data)

                } else {
                    setProducts(resData.data)
                    setFoundProduct(resData.data)
                }
            }
            if (resData && resData.error) {
                toast.dismiss();
                toast.error(ERROR_WHILE_FETCHING_PRODUCTS, {
                    autoClose: 3000,
                    onClose: () => { }
                })
            }
        })
    }

    const filterCategories = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = categoriesList.filter((category) => {
                return category.category_name.toLowerCase().startsWith(keyword.toLowerCase())
            });
            setFoundcategory(results)
        } else {
            setFoundcategory(categoriesList);
        }
        setCategory_name(keyword);
    };

    const filterProduct = (e) => {
        const keyword = e.target.value;
        if (keyword !== '') {
            const results = products.filter((product) => {
                return product.product_name.toLowerCase().startsWith(keyword.toLowerCase())
            });
            setFoundProduct(ar => results)
        } else {
            setFoundProduct(ar => products);
        }
        setProduct_name(keyword);
    };

    const closeBrowseCategoriesHandler = () => {
        setProducts(arr => [])
        setFoundProduct(arr => [])
        setShowBrowseCatogoriesModal(false);
    }

    const resetBrowseCategoriesModal = () => {

    }

    const ref = useRef()

    useEffect(() => {
        const checkIfClickedOutside = e => {
            if (dropDownList !== -1 && ref.current && (!ref.current.contains(e.target) || e.target?.id === "reset")) {
                setDropDownList(0)
                setSearch("")
            }
        }
        document.addEventListener("mousedown", checkIfClickedOutside)
        return () => {
            document.removeEventListener("mousedown", checkIfClickedOutside)
        }
    }, [])

    return (
        <React.Fragment>
            {showBrowseCatogoriesModal &&
                <BrowseCategoriesModal
                    formik={formik}
                    show={true}
                    lines={lines}
                    closeModal={closeBrowseCategoriesHandler}
                    resetModal={resetBrowseCategoriesModal}
                    categoriesList={categoriesList}
                    getProducts_={getProducts_}
                    selectedProducts={products}
                    setSelectedProducts={setProducts}
                    label={category_name}
                    filterCategories={filterCategories}
                    foundCategory={foundCategory}
                    setFoundcategory={bool => setFoundcategory(bool)}
                    product_name={product_name}
                    filterProduct={filterProduct}
                    foundProducts={foundProduct}
                    setFoundProduct={bool => setFoundProduct(bool)}
                    setLines={setLines}
                    loading={product_loading}
                />
            }
            <Table className="mb-0 saleOrder-table">
                <thead>
                    <tr>
                        {props.column_product && (<th><p className="text-capitalize">Product/Service</p></th>)}
                        {props.column__quantity && (<th><p className="text-capitalize">Qty</p></th>)}
                        {props.column__itemPrice && (<th><p className="text-capitalize">Item Price</p></th>)}
                        {props.column__itemTotal && (<th><p className="text-capitalize">Item Total</p></th>)}
                        <th><p></p></th>
                    </tr>
                </thead>
                <tbody>
                    {lines.map((line, index) => {
                        return (
                            <tr key={index} id={"tr" + index}
                                className={`product-row st-border-light`}>
                                <td className="column_product d-flex align-items-center" id="column-product">
                                    <div className="w100 d-flex align-items-center ptb-16"
                                        onClick={(e) => {
                                            getProducts_("", "")
                                            setDropDownList(index + 1)
                                        }}>
                                        <div className="product_name">{line.product_name || "Select a Product/Service"}
                                            {line.variant_sku && <br />}
                                            <span>{line.variant_sku}</span>
                                            {(line.variant || line.variant_name) && <br />}
                                            <span>{line.variant || line.variant_name}</span>
                                        </div>
                                        <div className="icon_">
                                            <FeatherIcon
                                                icon="chevron-down"
                                                size="16"
                                                className="icon me-1" />
                                        </div>
                                    </div>
                                    {((index + 1) === dropDownList) ? <div className="dropDownList"
                                        ref={ref} key={index} id={"ddl" + index}
                                    >
                                        <Row id="dropdownlist-btn" className="m-0" >
                                            <Col lg={6}>
                                                <Link
                                                    type="submit"
                                                    target="_blank"
                                                    className={`st-btn  st-btn-transparent st-btn-sm  w-100 d-flex align-items-center justify-content-center text-primary st-border-none`}
                                                    // disabled={createButtonDisable}
                                                    // onClick={addNewProductHandler}
                                                    to={storeUrl + "/catalog/products/create#general_tab"}
                                                >
                                                    <FeatherIcon
                                                        icon="plus-circle"
                                                        size="14"
                                                        className="icon me-1" />

                                                    <span>Add New Product</span>
                                                </Link>
                                            </Col>

                                            <Col className="border-left" lg={6}
                                                onClick={(e) => {
                                                    setDropDownList(0)
                                                    setShowBrowseCatogoriesModal(true)
                                                    setSearch("")
                                                }}>
                                                <button
                                                    type="submit"
                                                    className={`st-btn no-min-width st-btn-transparent w-100 st-btn-sm  no-min-width d-flex align-items-center justify-content-center text-primary st-border-none`}
                                                >
                                                    <FeatherIcon
                                                        icon="plus-circle"
                                                        size="14"
                                                        className="icon me-1"
                                                        id="reset1" />

                                                    <span>Browse Categories</span>
                                                </button>
                                            </Col>
                                        </Row>
                                        <Row className="sale-order-dropdown-item">
                                            <Col lg={12}>
                                                <div className="app-card-content st-border-light align-items-center">
                                                    <Row className="align-items-center">
                                                        <div className="app-card" id="categories">
                                                            <div className="app-card-content-category st-default-rounded-block ">
                                                                <div className="rt_item st-form form-sm st-form-with-icon-left search mb-0 mb-4 pad-12-L pad-12-R pad-12-T" >
                                                                    <label className="d-none st-label-with-left me-2" value={category_name}>Search</label>
                                                                    <input type="text"
                                                                        className="form-control"
                                                                        value={search}
                                                                        placeholder="Search Product"
                                                                        onChange={(e) => {
                                                                            const value = e.target.value || ""
                                                                            setSearch(value)
                                                                            if (timeOut) {
                                                                                clearTimeout(timeOut)
                                                                            }
                                                                            timeOut = setTimeout(() => {
                                                                                timeOut = ""
                                                                                getProducts_("", value)
                                                                            }, 1000);

                                                                        }} />
                                                                    <div className="icon-search">
                                                                        <FeatherIcon
                                                                            icon="search"
                                                                            size="15"
                                                                            className="icon-main" />
                                                                    </div>
                                                                </div>
                                                                <div className="product-content">
                                                                    {<div>
                                                                        {(product_loading && searchProducts.length === 0) ?
                                                                            <div className="app-modal-loading-overlay  d-flex align-items-center justify-content-center">
                                                                                <Spinner animation="border" />
                                                                            </div> : (
                                                                                searchProducts.length === 0 ? "No product found" : ""
                                                                            )}
                                                                    </div>}

                                                                    {(searchProducts && searchProducts.length > 0) && searchProducts.map((item, index) =>
                                                                        <div key={index}>
                                                                            <Product item={item}
                                                                                {...props}
                                                                                selectedProducts={products}
                                                                                setSelectedProducts={setProducts} />
                                                                        </div>
                                                                    )}
                                                                </div>
                                                                <div className="app-card-content border d-flex align-items-center justify-content-end pad-12-T pad-12-B st-border-no-left "
                                                                    style={{ borderRadius: "0px 0px 8px 8px" }}
                                                                >
                                                                    <button
                                                                        type="button"
                                                                        className={`st-btn no-min-width st-btn-gray st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto`}
                                                                        onClick={() => {
                                                                            setDropDownList(0)
                                                                            setSearch("")
                                                                        }}
                                                                    >
                                                                        <FeatherIcon
                                                                            icon="rotate-ccw"
                                                                            size="14"
                                                                            className="icon me-1"
                                                                        />
                                                                        <span id="reset">Reset</span>
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className={`st-btn no-min-width st-btn-primary st-btn-sm  no-min-width d-flex align-items-center justify-content-center me-2 min-height-auto ${searchProducts.length === 0 ? "disabled" : ""}`}
                                                                        disabled={searchProducts.length === 0}
                                                                        onClick={() => {
                                                                            setDropDownList(0)
                                                                            setSearch("")
                                                                            setLines(arr => [...arr, ...searchProducts.filter(e => e.selected)].filter(e => e.product_name))
                                                                        }}
                                                                    >
                                                                        <FeatherIcon
                                                                            icon="download"
                                                                            size="14"
                                                                            className="icon me-1"
                                                                        />
                                                                        <span>Save</span>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </div>

                                            </Col>
                                        </Row>
                                    </div> : ""
                                    }
                                </td>

                                <td className={`product-quantity  ${line.product_name ? ((!parseInt(line.quantity) || ((line.variant_stock || line.stock) < line.quantity)) ? "st-border-red" : "") : "quantity-pad-L"} `}>
                                    {line.product_name ? <div className="d-flex">
                                        <div>
                                            <button
                                                className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    if (line.quantity) {
                                                        line.quantity = line.quantity - 1
                                                    }
                                                    lines[index] = line
                                                    setLines(arr => [...lines])
                                                }}
                                            >
                                                <FeatherIcon
                                                    icon="minus"
                                                    size="16"
                                                    className="icon" />
                                            </button>
                                        </div>
                                        <input
                                            className="form-control min80"
                                            id={"qty" + index}
                                            value={line.quantity}
                                            type="number"
                                            onChange={(e) => {
                                                const quantity = e.target.value
                                                if (quantity < 0) {
                                                    line.quantity = 0
                                                } else {
                                                    line.quantity = quantity
                                                }
                                                lines[index] = line
                                                setLines(arr => [...lines])
                                            }}
                                        />
                                        <div>
                                            <button
                                                className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                                onClick={() => {
                                                    line.quantity = line.quantity + 1
                                                    lines[index] = line
                                                    setLines(arr => [...lines])
                                                }}
                                            >
                                                <FeatherIcon
                                                    icon="plus"
                                                    size="16"
                                                    className="icon" />
                                            </button>
                                        </div>
                                        <div>


                                        </div>
                                        {(!parseInt(line.quantity) || ((line.variant_stock || line.stock) < line.quantity)) ?
                                            <div className="form-error position-absolute">
                                                <p className="st-fs-12">{!parseInt(line.quantity) ? "Required" : "Out of Stock"}</p>
                                            </div> : ""
                                        }
                                    </div> : <div className="disabled-text">0</div>}
                                </td>
                                <td className="column__itemPrice ">
                                    <p className="">
                                        {currency}{line.variant_price || line.price || 0}.00
                                    </p>
                                </td>
                                <td className="column__itemTotal ">
                                    <p className="">
                                        {currency}{((line.quantity || 0) * ((line.variant_price || line.price || 0) || (line.variant_price || line.price) || 0))}.00
                                    </p>

                                </td>

                                <td className={`column__actions`}>
                                    <div className="d-flex justify-content-center">
                                        <OverlayTrigger
                                            placement={"left"}
                                            overlay={renderTooltipDelete}>
                                            <button
                                                className="delete st-round-btn st-btn-xs d-flex align-items-center justify-content-center"
                                                // onClick={ev => props.handleDelete(ev, item.manufacturer_id)}
                                                onClick={() => {
                                                    const selItem = lines.find(e => (e.variant_sku || e.variant_sku) === (line.variant_sku || line.variant_sku))
                                                    if (selItem.cart_id) {
                                                        deleteCart_(selItem)
                                                    }
                                                    const array = lines.filter(e => (e.variant_sku || e.variant_sku) !== (line.variant_sku || line.variant_sku))
                                                    setLines(a => array)
                                                }}
                                            >
                                                <FeatherIcon
                                                    icon="trash-2"
                                                    size="16"
                                                    className="icon" />
                                            </button>
                                        </OverlayTrigger>
                                    </div>
                                </td>

                            </tr>
                        )
                    })
                    }
                </tbody>
            </Table >
        </React.Fragment >
    )
}

const getDataFromStore = state => {
    return {
        authState: state.auth,
    };
}

const dispatchActionsToProps = dispatch => {
    return {
        setGlobalLoading: bool => dispatch(setGlobalLoading(bool)),
    }
}

export default connect(getDataFromStore, dispatchActionsToProps)(SaleOrdersProductsTable)